import { PlanType } from 'dy-frontend-http-repository/lib/data/enums';

const planTypeInformation: { [planType in PlanType]: string } = {
    [PlanType.SEAT]: 'Seat',
    [PlanType.USER]: 'User',
    [PlanType.WORKSPACE]: 'Workspace',
};

export default planTypeInformation;
